import React, { useState, useEffect } from 'react';

import { AsyncSelect, Input, InputDate, SimpleSelect } from '../../../components/Input.components';
import { Grid } from '../../../components/Grid.components';
import { Boxed } from '../../../components/Boxed.components';
import { Text } from '../../../components/Text.components';
import { Button } from '../../../components/Button.components';
import { ModalComponent } from '../../../components/Modal.components';

import { calcViewMode } from '../../../utils/utils';
import { PageTitle } from '../../../components/style';
import { Uploader } from '../../../components/Uploader.components';
import { USER_TYPE } from '../../../utils/constant';

export const CreateModal = (props) => {
  // State props
  const {
    createUserModal,
    rolesList,
    isLoading,
    departmentsList,
    userTypesList,
    callCodesList,
    isLoadingDepartments,
    isLoadingUserTypes,
    isLoadingCallCodes,
    accessList,
    profile
  } = props;

  // Dispatch props
  const { form, createUser, closeModal, fetchAllDepartments, fetchAllUserTypes, fetchCallCodes } =
    props;
  console.log(props);
  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;

  let viewMode = calcViewMode();

  useEffect(() => {
    fetchAllDepartments();
    fetchAllUserTypes();
    fetchCallCodes();
  }, []);

  const [profileImage, setProfileImage] = useState('');
  const [showUploader, setShowUploader] = useState(true);
  const organization = localStorage.getItem('dapproval_app_organisation');
  const onSubmit = () => {
    validateFields((error, value) => {
      if (!error) {
        const data = {
          firstName: value.firstname.trim(),
          lastName: value.lastname.trim(),
          email: value.email.trim(),
          phoneNumber: {
            countryCode: value.callCode.value,
            phone: value.phone.trim()
          },
          department: value.department.value,
          userType: value.userType.value,
          status: 'active',
          profilePictureUrl: profileImage,
          organizations: [organization]
        };
        createUser(data);
      }
    });
  };
  const addImage = (e) => {
    const base64Image = `data:${e.type};base64,${e.base64}`;
    setProfileImage(base64Image);
    setShowUploader(false);
  };

  const modiUserTypeList = userTypesList.filter((item) => {
    if (
      !accessList[USER_TYPE?.ACCOUNT_DIRECTOR] &&
      (item?.description === USER_TYPE?.ACCOUNT_DIRECTOR)
    ) {
      return false;
    } else {
      return true;
    }
  });

  return (
    <>
      <ModalComponent
        show={createUserModal}
        onHide={closeModal}
        title={<PageTitle margin="5px 0">Add a new User</PageTitle>}
        footer={
          <Boxed display="flex" width="100%">
            <Button clear onClick={closeModal}>
              Cancel
            </Button>
            <Button
              margin="0 0 0 auto"
              progress={isLoading}
              disabled={isLoading}
              onClick={onSubmit}
            >
              Add User
            </Button>
          </Boxed>
        }
      >
        <Boxed>
          <Text fontWeight={800}>Profile Image</Text>
          {showUploader ? (
            <Uploader
              types={['image/png', 'image/jpeg']}
              message={'Click to add a profile image'}
              callBack={addImage}
            />
          ) : (
            <Boxed
              margin="10px auto"
              display="flex"
              flexDirection="column"
              alignItems="center"
              position="relative"
            >
              <img
                src={profileImage}
                alt="profile"
                style={{
                  width: '160px',
                  height: '160px',
                  borderRadius: '9999px'
                }}
              />
              <Boxed
                bColor="#ffff"
                pad="5px 8px"
                borderRadius="9999px"
                position="absolute"
                bottom="24px"
                onClick={() => setShowUploader(true)}
              >
                <i className="icon-edit-2" style={{ fontSize: '22px' }} />
              </Boxed>
            </Boxed>
          )}
        </Boxed>

        <Grid
          desktop="repeat(2, 1fr)"
          tablet="repeat(2, 1fr)"
          mobile="repeat(1,1fr)"
          pad="0 0 30px 0"
        >
          <Boxed pad="10px 0">
            <Input
              type="text"
              label="First Name"
              placeholder="Enter first name..."
              error={getFieldError('firstname') ? 'First name is required' : null}
              {...getFieldProps('firstname', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>
          <Boxed pad="10px 0">
            <Input
              type="text"
              label="Last Name"
              placeholder="Enter last name..."
              error={getFieldError('lastname') ? 'Last name is required' : null}
              {...getFieldProps('lastname', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>

          <Boxed pad="10px 0">
            <Input
              type="text"
              label="Email"
              placeholder="Enter email..."
              error={getFieldError('email') ? 'Email is required' : null}
              {...getFieldProps('email', {
                initialValue: '',
                rules: [{ required: true, email: true }]
              })}
            />
          </Boxed>
          <Boxed pad="10px 0">
            <Input
              type="text"
              label="Phone Number"
              // width={"85%"}
              placeholder="Enter phone number..."
              error={getFieldError('phone') ? 'Phone number is required' : null}
              {...getFieldProps('phone', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>
          <Boxed pad="10px 0">
            <AsyncSelect
              label="Country"
              placeholder="Select Country"
              isLoading={isLoadingCallCodes}
              // width={"80%"}
              options={
                callCodesList?.map((item) => ({
                  label: `${item?.code} ${item?.dial_code}`,
                  value: item?.dial_code
                })) ?? []
              }
              error={getFieldError('callCode') ? 'call code is required' : null}
              {...getFieldProps('callCode', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>

          <Boxed pad="10px 0">
            <AsyncSelect
              label="Department"
              placeholder="Select Department..."
              isLoading={isLoadingDepartments}
              options={
                departmentsList?.map((item) => ({
                  label: item?.description,
                  value: item._id
                })) ?? []
              }
              error={getFieldError('department') ? 'Department is required' : null}
              {...getFieldProps('department', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>

          <Boxed pad="10px 0">
            <AsyncSelect
              label="User type"
              placeholder="Select user type..."
              isLoading={isLoadingUserTypes}
              options={
                modiUserTypeList?.map((item) => ({
                  label: item?.description,
                  value: item._id
                })) ?? []
              }
              error={getFieldError('userType') ? 'User type is required' : null}
              {...getFieldProps('userType', {
                initialValue: '',
                rules: [{ required: true }]
              })}
            />
          </Boxed>
        </Grid>
      </ModalComponent>
    </>
  );
};
